import { gql } from "@apollo/client";

export const PACIENTE_GEOPOSICIONAMIENTO_ACTUALIZADO = gql`
query PacienteGeoposicionActualizada(
    $idPaciente: Int!,
    $codPaciente: String!,
    $idEvaluacion: Int!) {
    pacienteGeoposicionActualizada(
        idPaciente: $idPaciente,
        codPaciente: $codPaciente,
        idEvaluacion: $idEvaluacion) {
        success
        error
        valorEsperado
    }
}
 `;